import "./scss/_pricer.css";
import PriceItem from "./priseList";
export default function Priser() {
    const priceList = [
        { service: "Fotbehandling (Basis)", price: "750 NOK", describe: "En komplett behandling som gir sunne, myke og velstelte føtter", detail: "Slik foregår behandlingen:\n" +
                "Vurdering av hud, negler og belastningsområder\n" +
                "Fotdesinfisering -Fotbad\n" +
                "Skånsom fjerning av hard og tørr hud\n" +
                "Klipp, rens og filing av negler\n" +
                "Polering av huden med slipemaskin\n" +
                "Avsluttende påføring med fuktighetskrem" },
        { service: "Negleklipp(ukomplisert), fra", price: "500 NOK" , describe: "Vanskelig å klippe negler uten hjelp? jeg kan gjøre det for deg", },
        { service: "Negleklipp(komplisert), fra", price: "750 NOK" , describe: "tykke, sopp infeksjon, psoriasis, innrullede negler", },
        { service: "Behandling av nedgrodd tånegl", price: "550 NOK" , describe: "For deg som opplever smerte, trykk eller betennelse rundt neglekanten", detail: "Behandlingen inkluderer:\n" +
                "Grundig vurdering av neglen\n" +
                "Fjerning av trykkende hud rundt neglkanten\n" +
                "Løfting og korrigering av neglen – med spange (bøyle) elle moderne system ved behov"},
        { service: "Fjerning av liktorn, fra", price: "380 NOK" , describe: "En effektiv behandling for smertefulle, punktvise hudfortykkelser", detail: "Undersøkelse av liktornens plassering og dybde\n" +
                "Presis fjerning av kjernen med skalpell og bor\n" +
                "Polering av området for en jevn og myk finish\n" +
                "Råd om avlastning og forebygging\n"},
        { service: "Hard hud og hælsprekker", price: "600 NOK" , describe: "For tørre, ru eller sprukne hæler", detail: "Slik behandler vi dette:\n" +
                "Mykgjøring av huden\n" +
                "Skånsom fjerning av hard hud\n" +
                "Slipemaskin for jevn overflate\n" +
                "Rensing og beskyttelse av dype sprekker\n" +
                "Påføring av intensiv fuktighetskrem"},
        { service: "Sopp Test", price: "550 NOK" , describe: "sopp test"},


    ];

    const priceList2 = [
        { service: "Fotmassasje", price: "350 NOK", describe: "Sirkulasjonsfremmende fotmassasje", detail: "Kartlegging av ømme områder\n" +
                "Massasje av fotbue, hæl, tær og ankler\n" +
                "Lett tøying for bedre bevegelighet" },
        { service: "Vortebehandling (Fotvorter)", price: "350 NOK" , describe: "Effektiv behandling for plagsomme fotvorter", detail: "Slik foregår det:\n" +
                "Fjerning av overflødig hud over vorten\n" +
                "Påføring av etsende middel eller frysebehandling (dersom tilgjengelig).-\n" +
                "Informasjon om videre hjemmebehandling og forebygging\n" +
                "Gebyr kan kreve flere behandlinger for full effekt"},
        { service: "Kinesiologitaping av Føtter", price: "150 NOK" , describe: "Skånsom støtte ved ulike fotplager", detail: "Kinesiologitaping er en effektiv og skånsom metode som gir støtte til muskulatur, ledd og sener – uten å begrense bevegeligheten. Tapen hjelper med å redusere smerte, bedre sirkulasjonen og avlaste utsatte områder i foten. Behandlingen tilpasses individuelt etter fotens behov og type plage."},
        { service: "Induviduell avlastning, fra", price: "150 NOK" , describe: "Skreddersydde løsninger for smerter, feilstillinger og belastningsproblemer", detail: "Fot- og ganganalyse\n" +
                "Identifisering av trykkpunkter\n" +
                "Tilpasning av ortoser og andre typer avlastninger\n" +
                "Oppfølging og justering etter behov"},
        { service: "Akuttime, fra", price: "1250 NOK" , describe: "Akuttime, negle- og fotskader"},
        { service: "Neglesopp,fra", price: "600 NOK" , describe: "Lokal behandling av neglesopp (ikke-systemisk)", detail: "Vurdering av neglens tilstand\n" +
                "Nedsliping av fortykkede negler\n" +
                "Rens og påføring av sopphemmende produkter\n" +
                "Råd om hygiene og forebygging"},
        { service: "Ortonyksi, fra", price: "350 NOK" , describe: "Typer av korrekksjons systemer", detail: "Spange, unguisan, neglebøyle"},
    ];
    return (
        <section id="priser">
            <div className="cs-container">
                <div className="cs-content">
                    <h2>Våre priser</h2>

                </div>
                <div className="cs-menu">
                    <ul className="cs-menu-group">
                        {priceList.map((item, idx) => (
                            <PriceItem key={idx} item={item} />
                        ))}
                    </ul>
                    <ul className="cs-menu-group">
                        {priceList2.map((item, idx) => (
                            <PriceItem key={idx} item={item} />
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}